import { render, staticRenderFns } from "./sendBill.vue?vue&type=template&id=53b1376e"
import script from "./sendBill.vue?vue&type=script&lang=js"
export * from "./sendBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports